








import { Component, Vue } from "vue-property-decorator";
import CzIcon from "./CzIcon.vue";

// A horizontal, snapping row of cards that bleeds to the screen edge; with a mouse, arrows move it a card at a time.
@Component({ components: { CzIcon } })
export default class CzScroller extends Vue {
  move(direction: number) {
    const row = this.$refs.row as HTMLElement;
    const card = row.firstElementChild as HTMLElement | null;
    row.scrollBy({ left: direction * (card ? card.offsetWidth + 14 : row.clientWidth), behavior: "smooth" });
  }
}
